<template>
  <div class="form-group slides-wrapper" v-click-outside="slideDeselected">
    <label>Rest Slides</label>

    <draggable
      v-model="editableSlides"
      v-bind="dragOptions"
      class="slides-list"
      @end="updateSlides"
    >
      <div
        v-for="(slide, index) in editableSlides"
        :key="index"
        class="slide"
        :class="{ 'slide--no-bg': slide === '' }"
        @click="slideSelected($event, slide, index)"
      >
        <img v-if="slide !== ''" :src="`${$store.state.assetsPath}${slide}`" alt="" />
      </div>
    </draggable>

    <button type="button" class="btn btn-secondary" @click="addSlide">
      Add Slide
    </button>

    <modal-edit-box
      :isVisible="isSlideSelected"
      :isArrowVisible="true"
      :xPos="modalData.assetSelected.xPos"
      :yPos="modalData.assetSelected.yPos"
      @update="updateSlides"
      @remove="removeSlide(modalData.assetSelected.index)"
    >
      <fieldset slot="input" class="form-group form-group--sm mb-1">
        <input
          v-model="modalData.assetSelected.content"
          type="text"
          class="form-control form-control-lg"
          placeholder="no image attached"
          readonly
        />
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm">
        <button
          class="btn btn-secondary btn-block btn-sm"
          @click="openAssetLibrary('restImage', modalData.assetSelected)"
        >
          Attach Image
        </button>
      </fieldset>
    </modal-edit-box>
  </div>
</template>
<script>
import draggable from "vuedraggable";

export default {
  name: "rest-slides",

  components: {
    draggable
  },

  props: {
    restSlides: Array
  },

  data() {
    return {
      editableSlides: this.restSlides,

      isSlideSelected: false,

      modalData: {
        assetSelected: {
          content: {},
        }
      }
    };
  },

  computed: {
    dragOptions() {
      return {
        animation: 120,
        group: "restSlides",
        disabled: false,
        ghostClass: "ghostly"
      };
    },

    highestId() {
      let ids = [0];

      this.editableSlides.forEach(bg => {
        if (!isNaN(bg._id)) {
          ids.push(bg._id);
        }
      });

      return (Math.max(...ids) + 1).toString();
    }
  },

  methods: {
    addSlide() {
      this.editableSlides.push("");
    },

    updateSlides() {
      this.isSlideSelected = false;
      this.$emit("updateSlides", this.editableSlides);
    },

    removeSlide(index) {
      this.isSlideSelected = false
      this.editableSlides.splice(index, 1)
      this.$emit('updateSlides', this.editableSlides)
    },

    slideSelected(event, item, index) {
      this.isSlideSelected = true;

      const modalWidth = 125;

      let modalLeft = event.target.offsetLeft + modalWidth / 2;
      let modalTop = event.target.offsetTop + event.target.offsetHeight + 7;

      this.modalData.assetSelected.content = item
      this.modalData.assetSelected.index = index
      this.modalData.assetSelected.type = 'restSlide'
      this.modalData.assetSelected.xPos = modalLeft
      this.modalData.assetSelected.yPos = modalTop

      this.$emit('setSlideAssetSelected', this.modalData.assetSelected)
    },

    slideDeselected() {
      this.isSlideSelected = false;
    },

    openAssetLibrary(context, assetSelected) {
      this.$emit("openAssetLibrary", context, assetSelected);
    }
  }
};
</script>
<style lang="scss" scoped>
.slides-wrapper {
  position: relative;
}

.slides-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.slide {
  background-size: cover;
  border-radius: 4px;
  cursor: move;
  font-size: 2.5px;
  height: calc(980px / 4);
  margin: 10px;
  overflow: hidden;
  position: relative;
  width: calc(1520px / 4);

  * {
    pointer-events: none;
  }

  &--no-bg {
    background-position: 0px 0px, 10px 10px;
    background-size: 20px 20px;
    background-image: linear-gradient(
        45deg,
        #eee 25%,
        transparent 25%,
        transparent 75%,
        #eee 75%,
        #eee 100%
      ),
      linear-gradient(
        45deg,
        #eee 25%,
        white 25%,
        white 75%,
        #eee 75%,
        #eee 100%
      );
  }

  img {
    height: 100%;
    overflow: hidden;
    width: 100%;
  }
}
</style>
